import React from 'react';

const GhostStarIcon = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.48052 11.9309L3.30372 14.185L4.10159 9.41069L0.722656 6.02986L5.39212 5.33383L7.48052 0.990227L9.56892 5.33383L14.2384 6.02986L10.8594 9.41069L11.6573 14.185L7.48052 11.9309Z"
        stroke={'#14607A'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GhostStarIcon;
